import { LegacyRef, Ref, forwardRef } from 'react';

import { Sizes, StyleTypes } from './enums';
import {
  Label,
  LeftIcon,
  RightIcon,
  Root,
  StyledLink,
  StyledLoader,
} from './styles';
import { Props } from './types';

const Button = (
  {
    className,
    disabled,
    id,
    label,
    leftIcon,
    loading,
    onClick,
    rightIcon,
    size = Sizes.medium,
    styleType = StyleTypes.filled,
    to,
    type = 'button',
    width100 = false,
    openInNewTab = false,
    ...rest
  }: Props,
  ref: unknown,
) => {
  const content = loading ? (
    <StyledLoader size={22} />
  ) : (
    <>
      {leftIcon && (
        <LeftIcon
          size={leftIcon.size}
          icon={leftIcon.type}
          $hasLabel={!!label}
          $buttonDisabled={disabled}
          {...leftIcon.props}
        />
      )}
      {label && <Label>{label}</Label>}
      {rightIcon && (
        <RightIcon
          size={rightIcon.size}
          icon={rightIcon.type}
          $hasLabel={!!label}
          $buttonDisabled={disabled}
          {...rightIcon.props}
        />
      )}
    </>
  );

  if (to) {
    return (
      <StyledLink
        ref={ref as Ref<HTMLAnchorElement>}
        {...(openInNewTab
          ? { target: '_blank', rel: 'noopener noreferrer' }
          : {})}
        className={className}
        to={to}
        onClick={onClick}>
        <Root
          disabled={disabled}
          styleType={styleType}
          size={size}
          $hasLabel={!!label}>
          {content}
        </Root>
      </StyledLink>
    );
  }

  return (
    <Root
      id={id}
      ref={ref as LegacyRef<HTMLButtonElement>}
      className={className}
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      styleType={styleType}
      size={size}
      $hasLabel={!!label && !loading}
      width100={width100}
      {...rest}>
      {content}
    </Root>
  );
};

export { StyleTypes, Sizes };
export type { Props };

export default forwardRef(Button);
